import React, { useEffect, useState, useRef } from "react";
import cta from "./Assets/cta-image.svg";

import { Drawer, Button, Grid, Carousel, List, Spin } from "antd";

import {
  RightOutlined,
  MenuOutlined,
  CloseOutlined,
  LeftOutlined,
  EnvironmentTwoTone,
  PhoneTwoTone,
  MailTwoTone,
  WhatsAppOutlined,
  ShoppingCartOutlined,
  CheckCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";

// Reveal
import AOS from "aos";
import "aos/dist/aos.css";

import "./styles.scss";
import "./button.scss";

import logo from "../../Assets/Logos/logo.png";
import history from "../../../history";

import heroImage from "./Assets/herobg.png";
import { getHomeCourses } from "../../Constants/Api/functions/function";
import {
  DEFAULT_COURSE_COVER_IMAGE,
  DEFAULT_USER_PROFILE_IMAGE,
} from "../../Constants/Api/azure/azure";
import { Link } from "react-router-dom";

import image1 from "./Assets/c1.jpg";
import image2 from "./Assets/c2.jpg";
import image3 from "./Assets/c3.jpg";
import image4 from "./Assets/c4.jpg";

import hero from "./Assets/hero.png";

// AOS.init();
// AOS.init({
//   disable: false,
//   startEvent: 'DOMContentLoaded',
//   initClassName: 'aos-init',
//   animatedClassName: 'aos-animate',
//   useClassNames: false,
//   disableMutationObserver: false,
//   debounceDelay: 50,
//   throttleDelay: 99,

//   offset: 120,
//   delay: 0,
//   duration: 500,
//   easing: 'ease',
//   once: false,
//   mirror: false,
//   anchorPlacement: 'top-bottom',
// });

const specifications = [
  {
    title: "Online Certification Exams (Certiport Partnership)",
    description:
      "We are an official Certiport partner, providing students with the ability to sit for online certification exams from the comfort of their homes. Our partnership with Certiport ensures that students can earn industry-recognized certifications, making them stand out in their career fields, including IT, digital literacy, and business productivity.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
        <circle cx="12" cy="8" r="6" />
      </svg>
    ),
  },
  {
    title: "Self-paced Learning through Video Tutorials",
    description:
      "Our extensive collection of video tutorials allows students to learn at their own pace. These tutorials cover a wide range of topics, enabling students to dive deep into subjects of interest and revisit content at any time, making learning flexible and pressure-free.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
        <rect x="2" y="6" width="14" height="12" rx="2" />
      </svg>
    ),
  },
  {
    title: "Lifetime Access to Recorded Online Classes",
    description:
      "Every class held online is recorded and made available to students for lifetime access. This feature allows students to revisit the material whenever needed, whether it's to reinforce concepts, prepare for exams, or simply refresh their knowledge months or even years after completing a course.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
  },
  {
    title: "Interactive Live Online Classes",
    description:
      "Our live classes are interactive, with instructors who engage students in discussions, problem-solving, and hands-on learning. This creates an environment similar to a physical classroom, ensuring that students don't miss out on the personal interaction and collaboration typically associated with in -person learning.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    title: "Certified and Experienced Instructors",
    description:
      "All our instructors are certified professionals with years of industry experience, ensuring students receive high-quality education and guidance. Their expertise helps students prepare for the challenges of the professional world while ensuring they are fully equipped to pass their certification exams.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
      </svg>
    ),
  },
  {
    title: "Personalized Learning Support",
    description:
      "We recognize that every student has unique learning needs. That's why we provide personalized support through one-on-one sessions, extra study resources, and dedicated mentors. Whether it's technical assistance, guidance in studies, or exam preparation, our team ensures every student feels supported throughout their learning journey.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M12 7v14" />
        <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
      </svg>
    ),
  },
  {
    title: "Practical Skills Development",
    description:
      "Our courses are designed to go beyond theoretical knowledge. We emphasize practical, hands-on skills development, ensuring that students can apply what they learn directly in the workplace. This helps them become job-ready and confident in their capabilities.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16" />
      </svg>
    ),
  },
  {
    title: "Affordable and Accessible Education",
    description:
      "We believe quality education should be accessible to all. Our pricing plans are designed to be affordable while offering value, allowing students from different backgrounds to benefit from our courses and certifications without financial burden.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <rect width="20" height="14" x="2" y="5" rx="2" />
        <line x1="2" x2="22" y1="10" y2="10" />
      </svg>
    ),
  },
  {
    title: "Affordable and Accessible Education for All",
    description:
      "Affordable and accessible education for all is essential for building a fair and progressive society. Every individual, regardless of their socioeconomic background, deserves the opportunity to learn, grow, and contribute meaningfully to the world.",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
        <line x1="8" y1="6" x2="16" y2="6" />
        <line x1="8" y1="10" x2="16" y2="10" />
        <line x1="8" y1="14" x2="13" y2="14" />
      </svg>
    ),
  },
];

const statsData = [
  {
    label: "Active Students",
    value: "2,500+",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    label: "Industry Certifications",
    value: "15+",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
        <circle cx="12" cy="8" r="6" />
      </svg>
    ),
  },
  {
    label: "Professional Courses",
    value: "50+",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M12 7v14" />
        <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
      </svg>
    ),
  },
  {
    label: "Student Satisfaction",
    value: "98%",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
        <path d="M2 12h20" />
      </svg>
    ),
  },
];

const features = [
  "Flexible learning schedules",
  "Expert instructors",
  "Industry-recognized certifications",
  "Lifetime access to course materials",
];

const avatars = [
  "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  "https://images.unsplash.com/photo-1548142813-c348350df52b?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
];

const testimonials = [
  {
    id: 1,
    content:
      "Digital Academy transformed my career path. The Microsoft certification I earned through their program helped me secure a better position with a 30% salary increase. The instructors were knowledgeable and supportive throughout my learning journey.",
    author: "Samantha Lee",
    position: "Marketing Specialist",
    company: "Global Media Inc.",
    image:
      "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    id: 2,
    content:
      "The flexibility of Digital Academy's courses allowed me to learn while working full-time. Their recorded sessions were invaluable, and I could revisit complex topics whenever needed. Within six months, I was able to transition to a new role in data analytics.",
    author: "Michael Rodriguez",
    position: "Data Analyst",
    company: "Tech Innovations Ltd.",
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    id: 3,
    content:
      "As someone with no prior technical background, I was impressed by how the instructors made complex concepts accessible. The personalized support and practical assignments prepared me for real workplace challenges. I'm now confidently leading projects in my company.",
    author: "Priya Patel",
    position: "Project Coordinator",
    company: "InnoSystems",
    image:
      "https://images.unsplash.com/photo-1548142813-c348350df52b?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    id: 4,
    content:
      "The certification exams through Digital Academy gave my resume the edge it needed. Their partnership with Certiport meant I could take industry-standard exams remotely, which was incredibly convenient. The prep materials were spot-on for what appeared on the test.",
    author: "David Chen",
    position: "IT Specialist",
    company: "Global Financial Services",
    image:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
];

const Landing = () => {
  const carouselRef = useRef(null);
  const [courses, setCourses] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  // "lg" becomes `true` once the viewport ≥ 992px (default AntD lg breakpoint)
  const isMobile = !screens.lg;

  const showDrawer = () => setDrawerVisible(true);
  const closeDrawer = () => setDrawerVisible(false);

  const skills = [
    { name: "Problem Solving", color: "#ff6b9d" },
    { name: "Critical Thinking", color: "#ffd93d" },
    { name: "Creative Expression", color: "#a8e6cf" },
    { name: "Teamwork & Confidence", color: "#ff9a56" },
  ];

  useEffect(() => {
    AOS.init({
      disable: false,
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 50,
      throttleDelay: 99,
      offset: 120,
      delay: 0,
      duration: 500,
      easing: "ease",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    });

    // Refresh AOS after content loads
    const timer = setTimeout(() => {
      AOS.refresh();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    // measure header height (plus optional extra gap)
    const header = document.querySelector("header");
    const headerOffset = header ? header.clientHeight + 16 : 0; // +16px breathing room

    // find element's absolute position
    const elementY = el.getBoundingClientRect().top + window.pageYOffset;

    // scroll so element sits just below header
    window.scrollTo({
      top: elementY - headerOffset,
      behavior: "smooth",
    });

    if (isMobile) closeDrawer();
  };

  useEffect(() => {
    handleGetHomeCourses();
  }, []);

  const handleGetHomeCourses = async () => {
    setIsLoading(true);
    try {
      const response = await getHomeCourses();
      const sortedResponse = response.sort(
        (a, b) => a?.orderNumber - b?.orderNumber
      );
      setCourses(sortedResponse);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  return (
    <div className="landing-page" id="landinghome">
      <header className="site-header">
        <div className="header-conteiner">
          {/* logo */}
          <div className="logo">
            <a href="/" aria-label="Digital Academy Home">
              <img src={logo} alt="Digital Academy Logo" />
            </a>
          </div>

          {/* hamburger icon, mobile only */}
          {isMobile && (
            <Button
              type="text"
              className="mobile-menu-icon"
              onClick={showDrawer}
              aria-label="Open Menu"
              icon={<MenuOutlined />}
            />
          )}

          {/* desktop navigation */}
          <div className="btns">
            <Button type="link" onClick={() => scrollToSection("courses")}>
              Courses
            </Button>
            <Button
              type="link"
              onClick={() => scrollToSection("features-heading")}
            >
              About Us
            </Button>
            <Button type="link" onClick={() => scrollToSection("footer")}>
              Contact
            </Button>
            <Link className="signin-btn" to="/exam-center">
              Exam Center
            </Link>
            <Link className="signin-btn" to="/register">
              Student Registration
            </Link>
            <Link className="signin-btn" to="/login">
              Sign In
            </Link>
          </div>
        </div>

        {/* mobile drawer */}
        {isMobile && (
          <Drawer
            placement="right"
            closable={true}
            onClose={closeDrawer}
            visible={drawerVisible}
            closeIcon={<CloseOutlined />}
            className="mobile-menu-drawer"
            width={280}
          >
            {/* <div className="drawer-logo">
            <img className='drawer-img' src={logo} alt="Digital Academy Logo" />
          </div> */}

            <div className="drawer-menu">
              <Button
                block
                type="link"
                onClick={() => scrollToSection("courses")}
              >
                <span>Courses</span>
                <RightOutlined />
              </Button>
              <Button
                block
                type="link"
                onClick={() => scrollToSection("features-heading")}
              >
                <span>About Us</span>
                <RightOutlined />
              </Button>
              <Button
                block
                type="link"
                onClick={() => scrollToSection("footer")}
              >
                <span>Contact</span>
                <RightOutlined />
              </Button>
              <Link to="/exam-center">
                <Button block type="link">
                  <span>Exam Center</span>
                  <RightOutlined />
                </Button>
              </Link>
              <Link to="/register">
                <Button block type="link">
                  <span>Student Registration</span>
                  <RightOutlined />
                </Button>
              </Link>
            </div>

            <div className="drawer-footer">
              <Link to="/login">
                <Button block type="primary" size="large">
                  Sign In
                </Button>
              </Link>
            </div>
          </Drawer>
        )}
      </header>

      <div className="body">

        <section
          className="hero"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          data-aos-easing="ease-out-cubic"
        >
          <div className="content">
            <h2>Welcome to</h2>
            <h1 className="gradient-text">Digital Academy</h1>
            <p>Hybrid Training Center for Distance Learning</p>

            <div className="buttons">
              <Link className="hero-cta-button" to="/dashboard/cources">
                Explore Courses
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    d="m9 18 6-6-6-6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                  />
                </svg>
              </Link>

              <Link className="signin-btn" to="/register">
                Register Now
              </Link>
            </div>
            <div className="hero-stats">
              <div className="stats-container">
                <div className="avatar-group">
                  {avatars.map((src, idx) => (
                    <img
                      key={idx}
                      src={src}
                      alt={`Student ${idx + 1}`}
                      className="avatar"
                    />
                  ))}
                </div>
                <div className="stats-text">
                  <p className="stats-title">Join 2,500+ students</p>
                  <div className="stats-rating">
                    {[...Array(5)].map((_, i) => (
                      <svg
                        key={i}
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        className="star"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                    <span className="rating-text">
                      4.9/5 from 1,200+ reviews
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="image">
            <img src={heroImage} alt="hero" />
          </div>
        </section>

        <section
          className="about"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          onLoad={() => AOS.refresh()}
        >
          <h1>Hybrid Training Center</h1>

          <p>
            We are a team of highly qualified and well experienced industry
            experts dedicated to providing hassle free, low cost and top quality
            online education to students from all corners in the island. We have
            experience in working both in Sri Lanka and overseas and we use
            state-of-the-art technologies mainly from industry leading software
            services giant Microsoft. We bring to you many paid software
            solutions and services for free.
          </p>

          <p>
            We provide your children an online education enriched with
            attractive audio visual content delivered by well experienced
            educators making education fun and exciting. We make the full use of
            latest technologies to educate, coach guide and mentor our exiting
            and our classes are much more than just a video call
          </p>
        </section>

        <section
          className="carousel-section"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          onLoad={() => AOS.refresh()}
        >
          <Carousel autoplay>
            <div>
              <img src={image1} alt="carousel 1" />
            </div>
            <div>
              <img src={image2} alt="carousel2" />
            </div>
            <div>
              <img src={image3} alt="carousel3" />
            </div>
            <div>
              <img src={image4} alt="carousel4" />
            </div>
          </Carousel>
        </section>

        <section
          id="courses"
          className="courses"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          onLoad={() => AOS.refresh()}
        >
          <div class="featured-courses">
            <h2>
              Our <span class="gradient-text">Featured Courses</span>
            </h2>
            <p className="para">
              Expand your knowledge and advance your career with our curated
              selection of professional courses.
            </p>
          </div>
          {/* <h1>
            Our Courses
          </h1> */}

          <div className="cources-body">
            <Spin tip="Loading..." spinning={isLoading}>
              {courses ? (
                <List
                  grid={{
                    gutter: 30,
                    xs: 1,
                    sm: 1,
                    md: 1,
                    lg: 2,
                    xl: 3,
                    xxl: 4,
                  }}
                  dataSource={courses}
                  renderItem={(item) => (
                    <List.Item>
                      <div className="course-card">
                        <div className="card-image-container">
                          <img
                            src={
                              item?.coverImage
                                ? item?.coverImage
                                : DEFAULT_COURSE_COVER_IMAGE
                            }
                            alt=""
                          />
                        </div>
                        <div className="card-body">
                          <div className="card-description">
                            <div className="price">
                              {item?.price === 0 ? (
                                <p className="free-text">Free</p>
                              ) : (
                                <p>{item?.price} LKR</p>
                              )}
                            </div>

                            <div className="author">
                              <img
                                src={
                                  item?.createdBy?.profileImage
                                    ? item?.createdBy?.profileImage
                                    : DEFAULT_USER_PROFILE_IMAGE
                                }
                                alt=""
                              />
                              <h3>{item?.createdBy?.name}</h3>
                            </div>
                          </div>

                          <h3 className="title">{item?.name}</h3>
                        </div>

                        <div className="card-footer">
                          <div className="button-continer">
                            <Link
                              className="view-btn"
                              to={`/dashboard/cources/${item?.id}`}
                            >
                              <Button type="link">View</Button>
                            </Link>

                            <>
                              {item?.whatsappGroupLink && (
                                <a
                                  href={item?.whatsappGroupLink}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <Button
                                    type="primary"
                                    style={{
                                      backgroundColor: "#25d366",
                                    }}
                                  >
                                    <WhatsAppOutlined />
                                    Join Whatsapp Group
                                  </Button>
                                </a>
                              )}
                            </>
                          </div>
                        </div>
                      </div>
                    </List.Item>
                  )}
                />
              ) : (
                <div className="no-courcesdiv"></div>
              )}
            </Spin>
          </div>
        </section>

        <section id="features-heading" className="courses margin_low">
          <div
            class="features-heading"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-offset="100"
            onLoad={() => AOS.refresh()}
          >
            <h2>
              Why Choose <span class="gradient-text">Digital Academy</span>
            </h2>
            <p className="para">
              Digital Academy: A Gateway to Flexible and Certified Learning
            </p>
            <p className="">
              Digital Academy is a forward-thinking educational institution that
              began as a hybrid training center, catering to the modern-day
              student. While offering the convenience of online classes, we
              ensure that our approach empowers students to balance their
              education with their personal and professional lives. As a proud
              partner of Certiport, we offer globally recognized certifications,
              helping students stay competitive in the job market.
            </p>
          </div>

          {/* <h3 className='heading-h3'>
              Here are the key advantages of studying with Digital Academy
          </h3> */}
          <div className="cources-body">
            <Spin tip="Loading..." spinning={isLoading}>
              <List
                grid={{
                  gutter: 30,
                  xs: 1,
                  sm: 1,
                  md: 1,
                  lg: 2,
                  xl: 3,
                  xxl: 3,
                }}
                dataSource={specifications}
                renderItem={(item) => (
                  <List.Item>
                    <div
                      key={item?.title}
                      className="list-card"
                      data-aos="fade-up"
                      data-aos-delay={item * 100}
                      data-aos-once="true"
                    >
                      <div className="icon-wrapper">{item?.icon}</div>
                      <h3>{item?.title}</h3>
                      <div className="description">
                        <p>{item?.description}</p>
                      </div>
                    </div>
                  </List.Item>
                )}
              />
            </Spin>
          </div>

          {/* <p className='para'>
            Digital Academy's mission is to make learning more accessible, flexible, and effective. With our comprehensive resources, personalized support, and industry-leading certifications, we are committed to helping students achieve their career goals and excel in today's competitive world.
          </p> */}
        </section>
      </div>

      <section
        className="stats-section"
        data-aos="fade-up"
        data-aos-duration="800"
        data-aos-offset="100"
        onLoad={() => AOS.refresh()}
      >
        <div className="stats-container">
          <div className="stats-grid">
            {statsData.map((s, i) => (
              <div
                key={i}
                className="stats-card"
                data-aos="fade-up"
                data-aos-delay={i * 100}
                data-aos-once="true"
              >
                <div className="stats-icon">{s.icon}</div>
                <div className="stats-text">
                  <p className="stats-value">{s.value}</p>
                  <p className="stats-label">{s.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="testimonials-section">
        <div
          className="container"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          onLoad={() => AOS.refresh()}
        >
          <h2 className="testimonials-title">
            What Our <span className="gradient-text">Students Say</span>
          </h2>
          <p className="testimonials-subtitle">
            Don't just take our word for it. Hear what our students have
            achieved with Digital Academy.
          </p>

          <div className="testimonial-carousel-wrapper">
            {/* Prev button */}
            <button
              className="arrow-btn prev-btn"
              onClick={() => carouselRef.current.prev()}
            >
              <LeftOutlined />
            </button>

            <Carousel
              ref={carouselRef}
              autoplay
              dots
              arrows={false} // disable default arrows
            >
              {testimonials.map((t) => (
                <div key={t.id}>
                  <div className="testimonial-card">
                    <p className="testimonial-content">"{t.content}"</p>
                    <div className="testimonial-author">
                      <img
                        src={t.image}
                        alt={t.author}
                        className="author-avatar"
                      />
                      <div className="author-info">
                        <h4 className="author-name">{t.author}</h4>
                        <p className="author-role">
                          {t.position}, {t.company}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>

            {/* Next button */}
            <button
              className="arrow-btn next-btn"
              onClick={() => carouselRef.current.next()}
            >
              <RightOutlined />
            </button>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div
          className="section-container"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          onLoad={() => AOS.refresh()}
        >
          <div className="cta-content">
            <div className="cta-image-wrapper">
              <img src={cta} alt="Start learning today" />
            </div>
            <div className="cta-text-wrapper">
              <h2 className="cta-title">
                Ready to{" "}
                <span className="gradient-text">Advance Your Career?</span>
              </h2>
              <p className="cta-description">
                Join thousands of students who have already enhanced their
                professional skills and boosted their careers with Digital
                Academy. Start your learning journey today.
              </p>
              <ul className="cta-features-list">
                {features.map((feat, idx) => (
                  <li key={idx}>
                    <svg
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="cta-icon"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>
              <div className="cta-buttons">
                <Link className="cta-button" to="/register">
                  Register Now
                </Link>
                <Link className="secondary-button" to="/dashboard/cources">
                  Browse Courses
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer id="footer">
        <div className="footer-sec">
          <div className="logo">
            <a href="/">
              <img src={logo} alt="logo" />
            </a>
          </div>
          <div className="text">
            <p>
              Experienced experts offer low-cost, high-quality online education
              globally, leveraging Microsoft's top technologies. Serving Sri
              Lanka and beyond, we provide free access to premium software
              solutions, aiming for hassle-free learning experiences for
              students island-wide.
            </p>
          </div>
        </div>

        <div className="footer-sec">
          <h3>Contacts</h3>
          <div className="text">
            <p>
              <span>
                <EnvironmentTwoTone />
              </span>
              634/A/8, Nugedeniya Rd, Thalangama South, Battaramulla. Sri Lanka.
            </p>
            <p>
              <span>
                <PhoneTwoTone />
              </span>
              +94-77 4747 920
            </p>
            <p>
              <span>
                <MailTwoTone />
              </span>
              <a href="/">info@digitalacademy.lk</a>
            </p>
          </div>
        </div>
      </footer>

      <section className="copy-right">
        <p>
          © 2025
          <a href="http://tuitionpanthiya.lk/" target="_blank" rel="noreferrer">
            {" "}
            Digital Academy.
          </a>{" "}
          All RIghts Reserved.
        </p>

        <p>
          Designed & Developed by
          <a
            href="https://www.kotuwegedara.com"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Kavinda Kotuwegedara
          </a>
        </p>
      </section>
    </div>
  );
};

export default Landing;
